export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const ADDONS = [
  { id: "pro-install", label: "Add Professional Installation", price: 199 },
  { id: "cable-concealment", label: "Add Cable Concealment", price: 149 },
  { id: "calibration", label: "Add Calibration", price: 129 },
  { id: "network-optimization", label: "Add Network Optimization", price: 99 },
  { id: "whole-home-audio", label: "Add Whole-Home Audio Setup", price: 349 },
];
export const money = (n) => `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Resolve a stored image/file path to an absolute URL. Relative "/api/..." paths
// must point at the backend origin (REACT_APP_BACKEND_URL), otherwise on the
// custom domain they resolve against the marketing host and 404.
export const imgUrl = (u) => {
  if (!u) return u;
  if (/^(https?:|data:|blob:)/i.test(u)) return u;
  if (u.startsWith("/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return u;
};

